import { BASE_URL } from './const'
import flat from './flat'

/**
 *
 * @param {string} id
 * @returns
 */
export const getProductDetails = id => {
  //api/mall/proxy/creditmall/get_credit_goods
  // const p = [id]
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_credit_goods_by_ids?ids=${id}`)
}

export const getCredit = () => {
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_credit_vo`)
}

//获取兑换记录
export const getAwardList = () => {
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_coupon_exchange_record`)
}

/**
 *获取优惠券提醒
 * @param {number} id -1 代表首页  商品ID 代表兑换页
 * @returns
 */
export const getRemindData = id => {
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_remind_coupon${id ? `?id=${id}` : ''}`)
}

/**
 * 兑换前的前置检查
 * @param {*} id
 * @returns
 */
export const prevCheck = id => {
  //https://learn.baicizhan.com/api/mall/proxy/creditmall/get_coupon_exchange_record
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/pre_check?id=${id}`)
}

/**
 *
 * @param {string} id
 * @returns
 */
export const exchange = id => {
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/credit_exchange?id=${id}`)
}
